import { FilterFieldDef } from './../../../covance-filter/covance-filter.models';
import { Injectable } from '@angular/core';
import { FilterFieldValue } from '../../../covance-filter/covance-filter.models';
import { CategoryNaturalKey } from '../../../documents/models/category';
import { 
    dateFilter, labReportTypeFilter, protocolFilter, siteFilter,
    sponsorFilter, subCategoryFilter, unreadOnlyFilter, externalProtocolFilter, unrespondedOnlyFilter, projectFilter, documentTypeFilter, sentDateFilter, ageFilter, statusFilter
} from '../../../documents/document-filter-definitions';
import { FilterResolver } from '../../../documents/filter-resolver';


@Injectable()
export class AdminActivityReportsFilterResolver implements FilterResolver {
    private filterTypesDictionary: { [key in CategoryNaturalKey]?: FilterFieldDef[] };

    constructor() {
        this.fillDataFiltersDictionary();
    }

    public resolveFilters(categoryKey: CategoryNaturalKey): FilterFieldValue[] {
        const filterDefs = this.filterTypesDictionary[categoryKey] || [];
        return filterDefs.map(f => ({def: f}));
    }

    public resolveEQueryFilters(): FilterFieldValue[] {
        return [
            externalProtocolFilter,
            siteFilter,
            sponsorFilter,
            unrespondedOnlyFilter,
            dateFilter,
        ].map(f => ({def: f}));
    }

    private fillDataFiltersDictionary() {

        const sponsorCommunicationsFilters = [
            sponsorFilter,
            dateFilter
        ];

        const labReportsFilters = [
            externalProtocolFilter,
            siteFilter,
            unreadOnlyFilter,
            labReportTypeFilter,
            dateFilter,
        ];

        const generalCommunicationsFilters = [
            dateFilter
        ];

        const siteCommunicationsFilters = [
            externalProtocolFilter,
            siteFilter,
            unreadOnlyFilter,
            dateFilter
        ];

        const siteActionsFilters = [
            externalProtocolFilter,
            siteFilter,
            unreadOnlyFilter,
            dateFilter
        ];

        const labManualsFilters = [
            externalProtocolFilter,
            siteFilter,
            unreadOnlyFilter,
            subCategoryFilter,
            dateFilter
        ];

        const trainingMaterialsFilters = [
            externalProtocolFilter,
            siteFilter,
            unreadOnlyFilter,
            subCategoryFilter,
            dateFilter,
        ];

        const resultAlertsFilters = [
            externalProtocolFilter,
            siteFilter,
            unreadOnlyFilter,
            dateFilter
        ];

        const eQueryFilters = [
            externalProtocolFilter,
            siteFilter,
            sponsorFilter,
            unrespondedOnlyFilter,
            dateFilter,
        ];

        const eQuerySummaryFilters = [
            ageFilter,
            statusFilter,
        ];

        const emailNotificationFilters = [
            protocolFilter,
            projectFilter,
            documentTypeFilter,
            sentDateFilter,
        ];

        this.filterTypesDictionary = {
            'sponsor-communications': sponsorCommunicationsFilters,
            'lab-manuals': labManualsFilters,
            'lab-reports': labReportsFilters,
            'general-communications': generalCommunicationsFilters,
            'site-communications': siteCommunicationsFilters,
            'site-actions': siteActionsFilters,
            'training-materials': trainingMaterialsFilters,
            'result-alerts': resultAlertsFilters,
            'equery': eQueryFilters,
            'equery-summary': eQuerySummaryFilters,
            'email-notification': emailNotificationFilters
        };
    }
}